import { useMutation } from 'urql';
import { CreateOwnershipMutation, MutationCreateOwnershipArgs } from 'gql/graphql';
import { MUTATION_CREATE_OWNERSHIP, MUTATION_UPDATE_OWNERSHIP } from './graphql';

export const useCreateOwnership = (query?: any) => {
  const [results, execute] = useMutation<CreateOwnershipMutation>(query || MUTATION_CREATE_OWNERSHIP);

  return {
    execute: (data: MutationCreateOwnershipArgs) =>
      execute({ createEntityInput: data }),
    data: results.data?.CreateOwnership,
    ...results
  };
};

export const useUpdateOwnership = (query?: any) => {
  const [results, execute] = useMutation(query || MUTATION_UPDATE_OWNERSHIP);

  return {
    execute: (data: any) =>
      execute({ updateOwnershipInput: data }),
    data: results.data?.UpdateOwnership,
    ...results
  };
};
